import React from 'react';
import slack from './../assets/slack.png';
import google from './../assets/google.png';
import deloitte from './../assets/deloitte.png';
import ibm from './../assets/ibm.png';
import samsung from './../assets/samsung.png';

const Company = () => {
  return (
    <div className='companies-container py-10'>
        <div className='flex justify-around items-center flex-wrap'>
          <img src={slack} alt='slack' />
          <img src={google} alt='google' />
          <img src={deloitte} alt='deloitte' />
          <img src={ibm} alt='ibm' />
          <img src={samsung} alt='samsung' />
        </div>
    </div>
  )
}

export default Company
